import { render, staticRenderFns } from "./areaAcademyVideo.vue?vue&type=template&id=c1640068&scoped=true&"
import script from "./areaAcademyVideo.vue?vue&type=script&lang=js&"
export * from "./areaAcademyVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1640068",
  null
  
)

export default component.exports